// extracted by mini-css-extract-plugin
export var displayNone = "_pf-6";
export var imgContainer = "_pf-2";
export var overflowHidden = "_pf-3";
export var productInfoCardButtonContainer = "_pf-5";
export var productTitleText = "_pf-4";
export var rightArrow = "_pf-1";
export var rightArrowContainer = "_pf-0";